module.exports = __webpack_public_path__ + "img/C08TechJuggernautChampion_ua.fc35228e.webp";